import { AssetGroupItem } from '../store/types';

export type SecurityLinkTarget = 'transactions' | 'cash' | null;

const CASH_MARKET_CODES = ['ADI', 'IDI'];

export const NonLinkableSecurityNames = ['pending cash', 'pending income'];

export function getSecurityLinkTarget(row: Pick<AssetGroupItem, 'securityCode' | 'securityName' | 'marketCode'>): SecurityLinkTarget {
  if (!row.securityCode) {
    return null;
  }

  const name = (row.securityName ?? '').trim().toLowerCase();
  if (NonLinkableSecurityNames.includes(name)) {
    return null;
  }

  const isCash = CASH_MARKET_CODES.includes((row.marketCode ?? '').trim().toUpperCase());
  return isCash ? 'cash' : 'transactions';
}
